import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'
import { Box, Collapse, Drawer, List, ListItemButton, ListSubheader } from '@mui/material'

import Icon from 'components/icon'
import CollapseListLangSwitcher from 'components/langSwitcher/collapseList'
import { navItems } from './navbar.static'

// initial all menu items to be collapsed
const defaultCollapseState = Object.fromEntries(
  new Map(
    navItems.map((item) => {
      return [item.name, false]
    })
  )
)
const CustomHeader = ({ children, className = '' }) => (
  <ListSubheader classes={{ root: `${className}` }} sx={{ lineHeight: '28px' }} disableSticky>
    {children}
  </ListSubheader>
)

const MenuList = () => {
  const { t } = useTranslation()
  const [collapseState, setCollapseState] = useState(defaultCollapseState)
  const [expandedItems, setExpandedItems] = useState({})
  const toggleNavItem = (name) => () => {
    setCollapseState({ ...defaultCollapseState, [name]: !collapseState[name] })
  }
  const toggleSubmenu = (name) => () => {
    setExpandedItems({ ...expandedItems, [name]: !expandedItems[name] })
  }

  return (
    <Box>
      <List disablePadding>
        {navItems.map((navItem) => (
          <React.Fragment key={navItem.name}>
            <ListItemButton
              classes={{ root: 'block px-4' }}
              component="a"
              onClick={toggleNavItem(navItem.name)}
              href={navItem.link}
            >
              <div className="flex font-bold items-center justify-between leading-6 overflow-hidden text-ellipsis text-gray-700 text-sm uppercase">
                <span>{t(navItem.name)}</span>
                {navItem.list ? (
                  <Icon
                    fontSize="16px"
                    name={collapseState[navItem.name] ? `arrow_drop_up_outlined` : `arrow_drop_down_outlined`}
                  />
                ) : null}
              </div>
            </ListItemButton>
            {navItem.list ? (
              <Collapse in={collapseState[navItem.name]} timeout="auto">
                <List>
                  {navItem.list &&
                    navItem.list.map((listItem) => (
                      <React.Fragment key={listItem.name}>
                        <CustomHeader className={navItem.key === 'products' ? 'border-b-2 border-black' : ''}>
                          <a className="font-bold text-gray-900" href={listItem.link}>
                            {t(listItem.name)}
                          </a>
                        </CustomHeader>
                        {listItem.list &&
                          listItem?.list.map((sectionItem) => (
                            <ListItemButton className="capitalize text-gray-700 text-sm" key={sectionItem.name}>
                              {sectionItem.list ? (
                                <div className="flex-1">
                                  <button
                                    onClick={toggleSubmenu(sectionItem.name)}
                                    className="flex justify-between w-full"
                                  >
                                    {navItem.key === 'products' ? (
                                      <span className="font-bold text-gray-900">{t(sectionItem.name)}</span>
                                    ) : (
                                      <React.Fragment>
                                        <span>{t(sectionItem.name)}</span>
                                        <Icon
                                          fontSize="16px"
                                          name={
                                            expandedItems[sectionItem.name]
                                              ? `arrow_drop_up_outlined`
                                              : `arrow_drop_down_outlined`
                                          }
                                        />
                                      </React.Fragment>
                                    )}
                                  </button>
                                  <Collapse in={navItem.key === 'products' ? true : expandedItems[sectionItem.name]}>
                                    <List>
                                      {sectionItem.list.map((sublist) => (
                                        <React.Fragment key={sublist.name}>
                                          {sublist.disable ? (
                                            <div className="cursor-not-allowed flex items-center text-gray-700/25">
                                              <Icon name="architecture_outlined" />
                                              <span className="leading-normal text-sm">{t(sublist.name)}</span>
                                            </div>
                                          ) : (
                                            <a
                                              key={sublist.name}
                                              href={sublist.link}
                                              target={sublist.target}
                                              className="block py-2"
                                            >
                                              {t(sublist.name)}
                                            </a>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </List>
                                  </Collapse>
                                </div>
                              ) : (
                                <a href={sectionItem.link}>{t(sectionItem.name)}</a>
                              )}
                            </ListItemButton>
                          ))}
                      </React.Fragment>
                    ))}
                </List>
              </Collapse>
            ) : null}
          </React.Fragment>
        ))}
        <CollapseListLangSwitcher />
      </List>
    </Box>
  )
}

const MenuDrawer = ({ isOpen, closeMenu }) => {
  const { t } = useTranslation()

  return (
    <Drawer
      anchor="right"
      classes={{ paper: `px-2 py-10` }}
      open={isOpen}
      onClose={closeMenu}
      PaperProps={{
        sx: { width: `300px` }
      }}
    >
      {MenuList()}
      <Link
        to="/signup/"
        className="btn bg-blue-300 border-2 border-blue-300 font-bold text-sm text-white uppercase mt-2 mx-4"
      >
        {t('button.freeTrial.0')}
      </Link>
      <Link
        to="/lp/get-a-demo/"
        className="btn border-2 border-blue-300 font-bold text-sm text-blue-300 uppercase mt-2 mx-4"
      >
        {t('button.getDemo.0')}
      </Link>
      <a className="btn font-bold mt-2 text-sm text-gray-700 uppercase" href="https://portal.mlytics.com/login">
        {t('navigation.buttonText')}
      </a>
    </Drawer>
  )
}

CustomHeader.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string
}
MenuDrawer.propTypes = {
  isOpen: PropTypes.bool,
  closeMenu: PropTypes.func
}
export default MenuDrawer
